module.exports = __webpack_public_path__ + "static/media/logo_fenseg.3a68bce7.png";